Label = createReactClass
  displayName: 'Label'

  render: ->
    <label {...@props}>
      {@props.children}
    </label>

module.exports = Label
